import React from 'react';
import dayjs from 'dayjs';
import { UserAvatar } from '../../../components/ui';
import { formatCurrency } from '../../../utils/baseUtils';
import { headerCls } from '../../../data/columns';

export const buildCompanySalesColumns = () => [
  {
    title: <span className={headerCls}>Company</span>,
    key: 'company',
    render: (_, report) => (
      <div className="flex items-center gap-3">
        {report.companylogo ? (
          <img
            alt="logo"
            className="h-9 w-9 shrink-0 rounded-full object-cover ring-1 ring-slate-200 dark:ring-slate-700"
            src={report.companylogo}
          />
        ) : (
          <UserAvatar name={report.companyname} size="sm" />
        )}
        <span className="text-sm font-semibold text-slate-900 dark:text-slate-100">
          {report.companyname || '-'}
        </span>
      </div>
    ),
  },
  {
    title: <span className={headerCls}>Live Time Sales</span>,
    key: 'ordertotal',
    sorter: (a, b) => (a.ordertotal || 0) - (b.ordertotal || 0),
    render: (_, report) => (
      <span className="text-sm font-bold tabular-nums text-slate-900 dark:text-slate-100">
        {formatCurrency(report.ordertotal)}
      </span>
    ),
  },
  {
    title: <span className={headerCls}>Live Time Orders</span>,
    key: 'ordercount',
    sorter: (a, b) => (a.ordercount || 0) - (b.ordercount || 0),
    render: (_, report) => (
      <span className="text-sm font-medium tabular-nums text-slate-700 dark:text-slate-200">
        {Number(report.ordercount || 0).toLocaleString('en-US')}
      </span>
    ),
  },
  {
    title: <span className={headerCls}>Avg Tips</span>,
    key: 'avgtips',
    sorter: (a, b) => (a.avgtips || 0) - (b.avgtips || 0),
    render: (_, report) => (
      <span className="text-sm tabular-nums text-slate-600 dark:text-slate-300">
        {formatCurrency(report.avgtips)}
      </span>
    ),
  },
  {
    title: <span className={headerCls}>Profit</span>,
    key: 'profit',
    sorter: (a, b) => (a.profit || 0) - (b.profit || 0),
    render: (_, report) => (
      <span className="text-sm font-semibold tabular-nums text-emerald-600 dark:text-emerald-400">
        {formatCurrency(report.profit)}
      </span>
    ),
  },
  {
    title: <span className={headerCls}>Start Date</span>,
    key: 'companycreatedate',
    sorter: (a, b) =>
      new Date(a.companycreatedate || 0) - new Date(b.companycreatedate || 0),
    render: (_, report) => (
      <span className="text-sm text-slate-500 dark:text-slate-400">
        {report.companycreatedate
          ? dayjs(report.companycreatedate).format('MMMM YYYY')
          : '-'}
      </span>
    ),
  },
];
